import * as React from "react";
import cn from "twsx";
import { NavTrailProvider } from "./NavTrail";

/** Use when building any app screen: AppShell wraps the app, and each screen is a Page, ListPage, FormPage, ProfilePage or StandardPage. */
export function AppShell({
  sidebar,
  topBar,
  children,
  className,
}: {
  sidebar: React.ReactNode;
  topBar?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <NavTrailProvider>
      <div
        data-app-shell=""
        className={cn("flex h-svh min-h-0 w-full flex-col overflow-hidden bg-bg-quaternary text-text-primary", className)}
      >
        {topBar}
        <div className="flex min-h-0 flex-1 overflow-hidden">
          {sidebar}
          <main className="flex min-w-0 flex-1 flex-col overflow-hidden [background-color:var(--shell-workspace-panel-bg)]">
            {children}
          </main>
        </div>
      </div>
    </NavTrailProvider>
  );
}

export function AppShellTopBar({ children, className }: { children: React.ReactNode; className?: string }) {
  return (
    <header
      data-app-shell-top-bar=""
      className={cn(
        "flex h-14 shrink-0 items-center justify-between gap-1 px-2 pt-safe-top md:hidden",
        "bg-sidebar-bg text-sidebar-text",
        className,
      )}
    >
      {children}
    </header>
  );
}
